import type { Translations } from './types';

const zh: Translations = {
  nav: {
    approvals: '审批',
    home: '首页',
    search: '搜索',
    dashboard: '控制台',
    outdoors: '户外广告',
    campaigns: '广告活动',
    admin: '管理员',
    logIn: '登录',
    signUp: '注册',
    logOut: '退出',
    account: '账户',
    setupBusiness: '设置企业',
    searchOutdoors: '搜索户外广告',
    manageOutdoors: '管理户外广告',
    verifyOutdoors: '验证户外广告',
    adminPanel: '管理员面板',
    upcomingCampaigns: '即将开始的活动',
    getPaid: '获取付款',
    revenue: '收入',
    payments: '付款',
  },
  common: {
    save: '保存',
    cancel: '取消',
    back: '返回',
    next: '下一步',
    done: '完成',
    loading: '加载中…',
    error: '出错了',
    confirm: '确认',
    delete: '删除',
    clear: '清除',
    edit: '编辑',
    add: '添加',
    search: '搜索',
    view: '查看',
    create: '创建',
    update: '更新',
    submit: '提交',
    yes: '是',
    no: '否',
    close: '关闭',
    upload: '上传',
    uploading: '上传中…',
    saving: '保存中…',
    creating: '创建中…',
    noResults: '暂无结果',
    required: '必填',
    optional: '可选',
    copy: '复制',
    copied: '已复制！',
    approve: '批准',
    reject: '拒绝',
    page: '页',
    of: '共',
    perDay: '/天',
    days: '{{count}} 天',
    days_plural: '{{count}} 天',
    termsAndConditions: '服务条款',
    selectCountry: '选择国家...',
    noCountriesFound: '未找到国家',
    notSet: '未设置',
    showPassword: '显示密码',
    hidePassword: '隐藏密码',
    refresh: '刷新',
    new: '新',
    rowsPerPage: '每页显示',
  },
  home: {
    tagline: '您的曝光驱动型OOH广告交易平台',
    heroTitle: '您的品牌，触达新高度',
    heroSubtitle:
      'Scapow 连接广告牌业主与广告主。浏览真实户外空间，规划广告活动，触达目标受众--一站式搞定。',
    browseOutdoors: '浏览户外广告',
    getStartedFree: '免费开始',
    featuredOutdoors: '精选户外广告',
    viewAll: '查看全部 →',
    howItWorksTitle: '如何使用',
    howItWorksSubtitle: '三个简单步骤，让您的信息触达正确受众。',
    step1Title: '找到完美位置',
    step1Desc:
      '按地点、尺寸和价格搜索广告牌，按活动日期筛选可用资源。',
    step2Title: '创建您的活动',
    step2Desc:
      '将多个户外广告添加到活动中，上传您的创意素材，获取支付详情。',
    step3Title: '追踪您的成效',
    step3Desc:
      '在控制台中监控活动进度、横幅投放状态和绩效指标。',
    builtTitle: '为双方而建',
    builtSubtitle:
      '无论您是广告牌业主还是广告主，Scapow 都能满足您的需求。',
    feature1Title: '发布您的广告位',
    feature1Desc:
      '轻松发布广告牌，设定价格，上传照片，管理可用时间。',
    feature2Title: '地图搜索',
    feature2Desc:
      '在实时地图上查找广告牌。放大缩小半径，拉远扩大覆盖范围。',
    feature3Title: '活动管理',
    feature3Desc:
      '创建包含多个户外广告的活动，上传创意素材，通过银行转账付款。',
    feature4Title: '经过认证的企业',
    feature4Desc: '所有企业在上线前均经过公司文件核验。',
    feature5Title: '绩效追踪',
    feature5Desc:
      '广告主和广告位提供商均可在控制台查看收入和活动概览。',
    feature6Title: '透明定价',
    feature6Desc: '供应商价格按天显示 - 确认前始终清晰可见。',
    ctaTitle: '准备好开始了吗？',
    ctaSubtitle: '立即加入 Scapow，开始连接户外广告市场。',
    createAccount: '创建账户',
    browseFirst: '先浏览',
    nearbyOutdoors: '附近的户外广告',
    detectingLocation: '正在检测您的位置…',
    basedOnLocation: '基于您的当前位置',
    welcomeBack: '欢迎，{{name}}',
    fromCompany: '来自{{company}}',
    ppPrompt: '您的所有户外广告位都准备好参与新的广告活动了吗？',
    advertiserPrompt: '您准备好创建一些广告活动了吗？',
    noCompanyPrompt: '设置您的企业以解锁所有功能。',
    goToDashboard: '前往控制台',
    inviteFrom: '{{company}} 已邀请您加入他们在 Scapow 的团队。',
    inviteFromDesc: '接受邀请，开始在户外广告活动中合作。',
    inviteAccept: '接受邀请',
    inviteDecline: '婉拒',
    inviteAccepted: '欢迎加入！您已成功加入 {{company}}。',
    inviteDeclined: '您已婉拒该邀请。',
    ppHowItWorksSubtitle: '将您的户外广告空间转变为稳定收入来源所需的一切。',
    ppStep1Title: '展示您的广告空间',
    ppStep1Desc: '以精美照片、准确尺寸和有竞争力的价格刊登您的户外广告位 - 让广告主一眼看出其价值。',
    ppStep2Title: '被品牌发现',
    ppStep2Desc: '您的广告位将出现在正在策划下一个广告活动的广告主搜索结果中。合适的活动会主动找到您。',
    ppStep3Title: '提交证明，获得报酬',
    ppStep3Desc: '广告位安装并运行后上传照片证明。审批通过后自动处理付款。',
  },
  auth: {
    login: {
      heroTitle: '将您的品牌与世界连接。每一次，迈向新的高度。',
      heroSubtitle:
        '连接广告牌业主与广告主的平台--简单、快速、有力。',
      title: '欢迎回来',
      subtitle: '登录您的账户以继续',
      email: '电子邮件地址',
      password: '密码',
      forgotPassword: '忘记密码？',
      resendVerification: '重新发送验证邮件',
      signIn: '登录',
      noAccount: '还没有账户？',
      createOne: '立即创建',
      invalidCredentials: '邮箱或密码无效，请重试。',
    },
    register: {
      heroTitle: '加入户外广告革命',
      heroSubtitle:
        '无论您是广告牌业主还是广告主，Scapow 让一切变得简单。',
      title: '创建您的账户',
      subtitle: '今天开始管理户外广告活动',
      firstName: '名字',
      lastName: '姓氏',
      email: '电子邮件地址',
      password: '密码',
      confirmPassword: '确认密码',
      passwordHint: '至少 8 个字符',
      createAccount: '创建账户',
      alreadyHaveAccount: '已有账户？',
      signIn: '登录',
      checkEmail: '查看您的邮件',
      checkEmailDesc:
        '我们已向您的电子邮件地址发送了验证链接。点击链接以激活您的账户。',
      goToLogin: '前往登录',
      termsAgreement: '我已阅读并同意',
      termsLink: '服务条款',
    },
    forgotPassword: {
      title: '重置密码',
      subtitle: '输入您的邮箱，我们将发送重置链接',
      email: '电子邮件地址',
      sendReset: '发送重置链接',
      backToLogin: '返回登录',
      checkEmail: '查看您的邮件',
      checkEmailDesc: '如果该地址已注册，您将很快收到重置链接。',
    },
    resetPassword: {
      title: '设置新密码',
      subtitle: '选择一个您能记住的强密码。',
      newPassword: '新密码',
      confirmPassword: '确认密码',
      save: '保存新密码',
      submit: '更新密码',
    },
    verifyEmail: {
      verifying: '正在验证您的邮箱…',
      success: '邮箱已验证！',
      successDesc: '您的账户现已激活，可以登录了。',
      error: '验证失败',
      errorDesc: '链接可能已过期或无效，请重新注册。',
      goToLogin: '前往登录',
      successDescBusiness: '您的账户现已激活，可以登录并设置您的企业。',
      returnToLogin: '返回登录',
      resendButton: '申请新的验证链接',
    },
    resendVerification: {
      title: '重新发送验证邮件',
      subtitle: '请输入您的电子邮件，我们将发送一个新的验证链接。',
      email: '电子邮件地址',
      send: '发送验证邮件',
      backToLogin: '返回登录',
      checkEmail: '请查看您的邮箱',
      checkEmailDesc: '如果您的账户正在等待验证，我们已将新链接发送至您的收件箱。',
    },
  },
  business: {
    pendingVerification: '您的企业账户目前正在审核中。一旦我们的团队完成验证，您将可以使用 Scapow 的所有功能。在此期间，请留意您的收件箱--如需提供额外文件，我们可能会与您联系。',
    setup: {
      title: '设置您的企业',
      subtitle: '将账户与企业实体关联，开始使用 Scapow。',
      ppTitle: '广告位提供商',
      ppDesc: '我拥有户外广告空间，希望将其出租。',
      advertiserTitle: '广告主',
      advertiserDesc: '我希望预订户外广告活动。',
      changeType: '更改 ↩',
      createCompany: '创建新企业',
      createCompanyDesc: '在 Scapow 注册您的企业。',
      joinCompany: '加入已有企业',
      joinCompanyDesc: '申请访问已注册企业的权限。',
      registerTitle: '注册您的企业',
      companyName: '公司名称',
      vatNumber: '税号',
      companyEmail: '公司邮箱',
      currency: '首选货币',
      currencyHint: 'ISO 货币代码，如 EUR、USD、GBP',
      country: '国家',
      proofDocument: '企业证明文件',
      proofHint: 'PDF、JPG 或 PNG',
      uploadProof: '点击上传企业证明',
      createCompanyBtn: '创建企业',
      bankTitle: '银行信息',
      bankSubtitlePP: '您的IBAN和SWIFT/BIC将用于户外广告活动上线后的付款结算。',
      bankSubtitleAdvertiser: '您的IBAN和SWIFT/BIC将用于处理适用的退款。',
      findTitle: '找到您的企业',
      searchPlaceholder: '按公司名称搜索…',
      noCompanies: '未找到公司，请按名称搜索。',
      requestAccess: '申请访问',
      requested: '已申请',
      accessSentMsg:
        '访问申请已发送！企业管理员需要批准。获批后您将收到通知。',
      pendingTitle: '访问申请待审核',
      pendingDesc: '您加入 {{name}} 的申请正在审核中。获批后您将收到通知。',
      cancelRequest: '取消申请',
      requestCancelled: '访问申请已取消。',
      connectingToEntity: '正在连接您的组织…',
      accessApproved: '您的访问申请已获批准！您现在已成为团队的一员。',
      accessRejected: '您的访问申请已被拒绝。请创建或加入另一个业务实体。',
      orSetupYourOwn: '或在下方注册您的企业或加入现有企业。',
      invitationsTitle: '待处理邀请',
      invitationsSubtitle: '您已被邀请加入一个企业。请在下方接受或拒绝。',
      invitedOn: '邀请日期',
      acceptInvitation: '接受',
      declineInvitation: '拒绝',
      invitationAccepted: '邀请已接受！正在连接您的组织…',
      invitationDeclined: '邀请已拒绝。',
    },
    details: {
      title: '公司详情',
      subtitle: '管理您的公司注册和银行信息。',
      registrationTitle: '注册详情',
      companyName: '公司名称',
      vatNumber: '税号',
      companyEmail: '公司邮箱',
      currency: '首选货币',
      country: '国家',
      portugueseRegion: '葡萄牙地区',
      regionContinent: '大陆',
      regionAzores: '亚速尔群岛',
      regionMadeira: '马德拉',
      replaceProof: '替换证明文件',
      uploadProof: '点击上传新的证明文件',
      saveChanges: '保存更改',
      addressSectionTitle: '地址',
      addressLine: '地址',
      addressLinePlaceholder: '中山路123号',
      city: '城市',
      postCode: '邮政编码',
      state: '州/省',
      stateHint: '美元账户为必填项',
      selectState: '请选择州',
      bankTitle: '银行详情',
      bankSubtitle: '用于接收广告主的付款。',
      bankSubtitlePP: '您的IBAN和SWIFT/BIC用于活动上线后的付款结算。',
      bankSubtitleAdvertiser: '您的IBAN和SWIFT/BIC用于适用时的退款处理。',
      bankClickUnlock: '已锁定 - 点击编辑',
      iban: 'IBAN',
      swift: 'SWIFT / BIC',
      ibanHint: '国际银行账户号码...',
      swiftHint: '8或11个字符：银行代码(4)+国家代码(2)+地点代码(2)+可选支行代码(3)',
      accountNumber: '账户号码',
      accountNumberHint: '您的美国银行账户号码(4-17位数字)',
      saveBankDetails: '保存银行详情',
      verifiedLocked: '公司名称、增值税号和国家在验证后将被锁定。',
      verifiedBadge: '已认证',
      pendingReviewTitle: '等待审核',
      pendingReviewDesc: '您的企业注册正在审核中。我们的团队批准后，您将立即获得平台完整访问权限--我们将实时通知您。',
      verifiedTitle: '身份已认证',
      verifiedDesc: '您的公司身份已获确认。无需提供其他文件。',
      proofCardTitle: '验证文件',
      proofCardDesc: '请上传贵公司的注册文件，以支持账户验证。我们的团队将进行审核，如需更多资料将与您联系。',
      proofCardSubmit: '提交审核',
      proofCardSuccess: '文件提交成功。我们的团队将进行审核，如有需要将与您联系。',
      proofCardValidatingTitle: '文件审核中',
      proofCardValidatingDesc: '您的验证文件已收到，目前正由我们的团队进行审核。审核完成后，我们将立即通知您。',
      proofCardProcessingTitle: '正在处理文件',
      proofCardProcessingDesc: '我们已收到您的文件，正在自动进行验证，很快就会完成。',
      proofCardReplaceFile: '提交错了文件？点击替换',
    },
  },
  search: {
    instantBookingHint: '即时确认，无需等待提供商审批',
    priceFilterLocked: '登录并关联企业实体后即可使用价格筛选。',
    title: '搜索户外广告',
    subtitle: '在地图上找到广告空间',
    filters: '筛选',
    minWidth: '最小宽度（米）',
    maxWidth: '最大宽度（米）',
    minHeight: '最小高度（米）',
    maxHeight: '最大高度（米）',
    minPrice: '最低价格（€/天）',
    maxPrice: '最高价格（€/天）',
    providerName: '提供商名称',
    clearFilters: '清除筛选',
    noResults: '该区域未找到户外广告',
    noResultsDesc: '请尝试扩大地图范围、调整筛选条件或延长广告活动时长，以获得更多可用选项。',
    addToCart: '加入购物车',
    inCart: '已在购物车',
    selectDates: '选择日期',
    from: '从',
    to: '至',
    results: '个结果',
    loading: '加载户外广告中…',
    resultsTab: '结果 ({{count}})',
    mapTab: '地图',
    searching: '搜索中…',
    found: '找到 {{count}} 个户外广告',
    found_plural: '找到 {{count}} 个户外广告',
    moveMap: '移动地图以更新结果',
    noticePeriodHint: '部分广告位提供商在广告活动开始前需要最短提前通知期或最短租赁期，这可能会影响可用性和搜索结果。',
    noOutdoorsFound: '未找到广告位',
    noOutdoorsFoundAdjustDates: '请尝试调整开始和结束日期，或缩小地图。',
    noOutdoorsFoundAdjustFilters: '缩小地图或调整筛选条件。',
    inCampaign: '已在广告活动中',
    attributes: '位于附近',
    withDiscounts: '提供批量折扣',
    illuminated: '仅显示有照明',
    illuminatedHint: '户外广告位有照明（如夜间）',
    containsDiscounts: '批量折扣',
    containsDiscountsDesc: '此广告位提供阶梯定价 - 预订天数越多，每日价格越低。',
  },
  outdoor: {
    startAtMonthFirstDay: '从每月1日开始',
    startAtMonthFirstDayHint: '预订必须从某个月的1日开始。与“仅限整月”同时启用时，按整个自然月（从1日到月末）预订。',
    acceptingToastOn: '{{name}} 现已开始接受新活动。',
    acceptingToastOff: '{{name}} 已暂停：不在搜索中显示，也不接受新预订。',
    acceptingToastBulkOn: '{{count}} 个户外广告位现已接受新活动。',
    acceptingToastBulkOff: '{{count}} 个户外广告位已暂停：不在搜索中显示，也不接受新预订。',
    fullMonthRequired: '仅限整月',
    fullMonthRequiredHint: '广告主按月预订：从开始日到下个月的同一天（从1日开始则到当月最后一天），可预订任意数量的连续月份。',
    fullMonthTooltip: '按月预订 - 从开始日到之后某个月的同一天。',
    stepsTitle: '户外广告位设置',
    stepNotSet: '尚未设置',
    stepLocationSet: '已标记位置',
    stepNoticeSummary: '提前通知：{{count}} 天',
    stepPhotosSummary: '照片：{{count}}',
    stepPhotosNone: '暂无照片',
    stepBlockedSummary: '屏蔽时段：{{count}}',
    stepOptional: '可选',
    stepFeaturesSummary: '已选：{{count}}',
    fixHighlightedFields: '部分信息需要修改，我们已打开有问题的步骤。',
    instantBooking: '即时预订',
    instantBookingTooltip: '立即预订，无需等待提供商确认。',
    instantBookingHint: '广告主可立即预订此户外广告位，无需等待您的审批。保持关闭即可先审核每笔预订。',
    kmAway: '距离 {{distance}} 公里',
    productionCost: '制作费',
    productionCostIncludes: '包括印刷、安装等费用',
    priceHiddenTitle: '每日价格仅对企业账户开放',
    priceHiddenMessage: '请登录并确保您已关联到企业实体（场地提供商或广告主），才能查看户外广告位的每日价格。',
    manageTitle: '管理户外广告',
    addNew: '添加新广告位',
    noOutdoors: '暂无广告位',
    noOutdoorsDesc: '添加您的第一个广告牌以开始接受预订。',
    addFirst: '添加您的第一个广告位',
    editTitle: '编辑广告位',
    createTitle: '添加新广告位',
    listSubtitle: '在 Scapow 上发布您的广告牌。',
    editSubtitle: '更新您的广告牌详情。',
    location: '位置',
    latitude: '纬度',
    longitude: '经度',
    name: '名称',
    namePlaceholder: '例：南京路 – 广告牌A',
    description: '描述',
    descriptionPlaceholder: '位于繁华商业街的优质广告牌，交通流量大…',
    dimensions: '尺寸与规格',
    width: '宽度（米）',
    height: '高度（米）',
    length: '长度（米）',
    aspectRatio: '创意素材比例',
    aspectRatioHint: '由宽度 ÷ 高度自动计算',
    bleed: '裁切边距 (m)',
    bleedHint: '超出最终裁切线的印刷区域，确保裁切后边缘整洁。',
    illuminated: '有照明',
    illuminatedHint: '该户外广告位配有照明，夜间仍可清晰可见。',
    currency: '货币',
    currencyLockedHint: '由您的场地提供商账户货币决定。',
    pricing: '定价',
    excludeVat: '不含增值税',
    vatIncluded: '含增值税',
    pricePerDay: '每天价格',
    volumeDiscounts: '批量折扣',
    addDiscount: '添加',
    daysArrow: '天 →',
    percentOff: '% 折扣',
    photos: '位置照片',
    photosHint: '照片在上传或删除时会自动保存。',
    uploadPhotos: '点击上传位置照片',
    addMorePhotos: '添加更多照片',
    currentPhotos: '当前照片',
    uploadingPhotos: '正在上传照片...',
    photosUploaded: '照片上传成功',
    deletePhotoTitle: '删除照片？',
    deletePhotoConfirm: '此照片将从该户外广告牌中永久删除。',
    filesSelected_one: '已选择 {{count}} 个文件',
    filesSelected_other: '已选择 {{count}} 个文件',
    blockedTimes: '已封锁时段',
    blockedTimesDesc:
      '封锁广告位不可用的日期（维修、外部预订等）。',
    blockedTimesOverlapNote: '日期范围不能互相重叠，也不能与已有的广告活动预订冲突。',
    blockFrom: '封锁开始',
    blockUntil: '封锁结束',
    addBlockedTime: '添加封锁时段',
    noBlockedTimes: '无封锁时段',
    occupiedByCampaign: '已被广告活动预订',
    unsaved: '未保存',
    unsavedChanges: '{{count}} 项未保存的更改 - 保存户外广告以应用',
    selectBlockedDates: '请选择开始日期和结束日期。',
    legalDeclaration: '我声明对此户外广告空间拥有合法权利，已获授权进行商业列示，且此举符合所有适用的法律、许可证及法规。',
    legalDeclarationRequired: '发布前，您必须确认对此广告空间拥有合法权利。',
    createOutdoor: '创建广告位',
    saveChanges: '保存更改',
    deleteTitle: '删除广告位',
    deleteConfirm: '确定要删除此广告位吗？此操作无法撤销。',
    hidden: '已隐藏',
    visible: '可见',
    viewDetails: '查看详情',
    bookingRules: '预订规则',
    bookingRulesDesc: '设置广告主在活动开始日期前必须满足的提前期要求。',
    minimumNoticeDays: '最低提前通知（天）',
    minimumNoticeDaysHint: '广告活动必须在开始日期前至少提前这么多天完成付款并上传创意素材。',
    minimumDays: '最低租用天数',
    minimumDaysHint: '广告主必须租用此广告位的最少天数。',
    acceptingCampaigns: '接受新广告活动',
    acceptingCampaignsOn: '此户外广告在搜索中可见，可加入广告活动。',
    acceptingCampaignsOff: '此户外广告已从搜索中隐藏，将不接受新预订。',
    acceptingBadge: '接受广告活动',
    notAcceptingBadge: '不接受广告活动',
    notAcceptingMsg: '此户外广告目前不接受新的广告活动。',
    unavailableForDates: '此户外广告在所选日期内不可用。',
    paused: '已暂停',
    accepting: '接受中',
    availabilityToggleTooltip: '该户外广告是否可用于广告活动。当前状态：{{state}}',
    availabilityStateOn: '可用',
    availabilityStateOff: '不可用',
    toggleError: '更新广告活动可见性失败。',
    bulkAccept: '为此页面上的所有户外广告启用接受广告活动',
    bulkPause: '为此页面上的所有户外广告暂停接受广告活动',
    commissionNote: '广告主将看到<bold>{{currency}} {{advertiserPrice}}/天</bold>的报价 - 您的{{currency}} {{basePrice}}加<bold>{{rate}}% Scapow佣金</bold>。',
    advertiserPaysLabel: '广告主支付',
    advertiserPaysDesc: '含{{rate}}% Scapow加价',
    youReceiveLabel: '{{name}} 收到',
    youReceiveDesc: '扣除{{rate}}%平台费后（佣金可能需缴纳增值税）',
    searchByAddress: '按地址搜索',
    dragPin: '拖动图钉以精确调整位置。',
    myOutdoors: '我的广告位',
    myOutdoorsSubtitle: '管理您的广告牌库存',
    viewCalendarTooltip: '查看此户外广告位的已锁定日期',
    calendarModalTitle: '日历 - {{name}}',
    addOutdoor: '添加广告位',
    searchByName: '按名称搜索…',
    deleteConfirmNamed: '确定要删除"{{name}}"吗？此操作无法撤销。',
    specifications: '规格',
    creativeRatio: '创意比例',
    coordinates: '坐标',
    price: '价格',
    plusVat: '+ 增值税',
    unavailableDates: '不可用日期',
    duration: '持续时间',
    addToCampaign: '加入广告活动',
    goToCampaign: '前往广告活动',
    signInToAdd: '请登录/注册以将此户外广告位添加至您的活动',
    bookingsCalendarTitle: '预订日历',
    bookingsCalendarSubtitle: '一目了然地查看您的活动何时开始、投放中及结束。选择一天即可查看当天已预订的户外广告位。',
    legend_starting: '活动开始',
    legend_startingDesc: '预订开始投放',
    legend_running: '活动投放中',
    legend_runningDesc: '您的户外广告位正在展示',
    legend_finishing: '活动结束',
    legend_finishingDesc: '预订的最后一天',
    legend_blocked: '已屏蔽日期',
    legend_blockedDesc: '您设为不可用的户外广告位',
    legend_none: '无预订',
    legend_noneDesc: '您的户外广告位均未被预订',
    legend_mixed: '颜色分割：当天有多项适用',
    calendarToday: '今天',
    selectDayHint: '选择一天查看其预订。再次点击即可取消。',
    clearDateSelection: '清除所选日期',
    dailyStatesError: '无法加载本月的预订，请尝试刷新。',
    searchBookedByName: '按名称搜索已预订的户外广告位…',
    clearSearch: '清除搜索',
    bookedOutdoorsCount: '已预订的户外广告位：{{count}}',
    noBookingsOnDate: '当天没有已预订的户外广告位',
    noBookedOutdoorsMatch: '当天没有与“{{name}}”匹配的已预订户外广告位',
    noBookingsOnDateHint: '请选择其他日期，或清除日期以查看所有户外广告位。',
    bookingPeriod: '预订期间',
    logIn: '登录',
    register: '注册',
    selectCampaignToAdd: '请选择一个活动以添加此户外广告位',
    changeCampaign: '更改',
    alreadyInCampaign: '已在广告活动中',
    billboardFallback: '户外广告牌',
    bookMoreThanDays: '预订超过 {{count}} 天',
    percentageOff: '{{percentage}}% 折扣',
    comingSoon: '您的广告位即将推出！',
    attributes: '位于附近',
    attributesHint: '帮助广告主更快找到您。标记周边设施与地标，提升您的广告位在搜索结果中的曝光率。',
  },
  outdoorDetail: {
    productionCost: '制作费',
    bookingTitle: '预订此广告位',
    startDate: '开始日期',
    endDate: '结束日期',
    estimatedCost: '预估费用',
    addToCart: '加入购物车',
    inCart: '已在购物车',
    specs: '规格',
    dimensions: '尺寸',
    aspectRatio: '所需比例',
    pricePerDay: '每天价格',
    location: '位置',
    blockedTimes: '封锁时段',
    discounts: '批量折扣',
    noBlockedTimes: '无封锁时段',
    noDiscounts: '暂无折扣',
    photos: '照片',
    days: '天',
    total: '合计',
    discount: '折扣',
    campaignBookings: '活动预订',
    inCampaign: '活动中',
    minimumNoticeInDays: '最低预订提前通知',
  },
  campaign: {
    methodFlowLabel: '付款方式',
    methodFirstPayment: '首次付款',
    methodCard: '银行卡',
    methodThenMonthly: '之后每月',
    methodThenTrimonthly: '之后每 3 个月',
    methodDirectDebit: '直接扣款',
    searchByName: '按名称搜索活动…',
    clearSearch: '清除搜索',
    resultsSummary: '结果：{{total}} · 第 {{page}} 页，共 {{pages}} 页',
    noSearchResults: '没有与“{{name}}”匹配的活动',
    noSearchResultsHint: '请检查拼写或尝试其他名称。',
    eventFeedbackReceived: '有提供商已就您活动中的户外广告位作出答复。',
    eventConfirmationUpdated: '您的活动确认已完成，请查看新状态。',
    eventViewCampaign: '查看活动',
    planTrimonthlyTitle: '每3个月付款',
    planTrimonthlyDesc: '现在支付制作费和前3个月的费用，之后每个3个月周期在首日通过直接扣款收取。',
    visitCampaignPage: '前往活动页面',
    payStepNotice: '付款时会重新检查户外广告位的可用性，如有变化，我们会在扣款前通知您。',
    removeOutdoor: '移除此户外广告位',
    noOutdoorsYetDesc: '在地图上为您的活动寻找户外广告位，然后选择日期。',
    creativesNeedOutdoors: '请先添加户外广告位，所需的创意素材取决于其尺寸。',
    stepAnnounce: '第 {{n}} 步，共 {{total}} 步：{{step}}',
    stepsDone: '已完成 {{done}} / {{total}}',
    stepDone: '已完成',
    stepToDo: '待完成',
    stepPrevious: '返回：{{step}}',
    stepNext: '下一步：{{step}}',
    stepOutdoorsSummary: '户外广告位：{{count}}',
    stepCreativesSummary: '已就绪 {{done}} / {{total}}',
    stepTermsAccepted: '已同意',
    stepTermsPending: '尚未同意',
    stepPendingHint_outdoors: '请至少添加一个户外广告位以继续。',
    stepPendingHint_creatives: '所有必需的创意素材都必须上传并获批。',
    stepPendingHint_terms: '同意条款后即可付款。',
    goToPayment: '前往付款',
    acceptTermsStepLabel: '我已阅读并同意此活动的条款和条件。',
    payStepTitle: '确认并付款',
    payStepMissingTitle: '完成以下步骤即可付款：',
    payStepTotal: '活动总额',
    scheduleTitle: '付款计划',
    scheduleTotal: '合计 {{amount}}',
    scheduleFullPayment: '全额付款',
    scheduleFirstPayment: '首笔付款 · {{month}}',
    scheduleDueAtCheckout: '结账时扣款',
    scheduleAuthorisedAtCheckout: '结账时预授权，提供商确认后扣款',
    scheduleDueOn: '{{date}} 扣款',
    schedulePaidOn: '已于 {{date}} 付款',
    scheduleProcessing: '处理中 - 直接扣款需要几天时间',
    scheduleFailed: '付款失败',
    scheduleCancelled: '已取消 - 不会扣款',
    scheduleSplit: '制作费 {{production}} · 投放天数 {{ads}}',
    scheduleVatIncluded: '所有金额均含增值税。',
    paymentsTitle: '付款',
    paymentsPaidSoFar: '已付金额',
    paymentsRemaining: '尚需支付 {{amount}}',
    paymentsFailedNotice: '一笔直接扣款未成功。请检查您的银行账户或联系我们，以免活动中断。',
    paymentPlanTitle: '您希望如何付款？',
    paymentPlanSubtitle: '请在结账前选择，付款前均可更改。',
    planTotalTitle: '一次性付清',
    planTotalDesc: '整个活动一次付款。',
    planMonthlyTitle: '按月付款',
    planMonthlyDesc: '现在支付制作费和第一个月的费用，之后每月 1 日通过直接扣款收取。',
    paymentPlanError: '无法更新付款方式。',
    checkoutAllInstant: '所有户外广告位均为即时预订：结账时即扣款，活动立即确认。',
    checkoutNeedsConfirmation: '{{total}} 个户外广告位中有 {{count}} 个需要提供商确认。结账时仅预授权您的银行卡，待提供商确认后才扣款，且只收取获批广告位的费用。',
    mandateStepTitle: '第 1 步，共 2 步 · 设置直接扣款',
    mandateStepDesc: '接下来，您将用银行卡完成首笔付款。',
    confirmingTitle: '等待提供商确认',
    confirmingDesc: '您的银行卡已预授权，尚未扣款。只会收取提供商批准的户外广告位的费用。',
    awaitingDecisionTitle: '部分户外广告位不可用',
    awaitingDecisionDesc: '继续使用已批准的户外广告位，或取消活动并释放付款。',
    providersAnswerBy: '提供商答复截止：{{date}}',
    decideBy: '请在 {{date}} 前决定，否则活动将被取消，不会扣款。',
    feedbackCount_approved: '已批准：{{count}}',
    feedbackCount_confirming: '等待答复：{{count}}',
    feedbackCount_unavailable: '不可用：{{count}}',
    feedbackCount_expired: '未按时答复：{{count}}',
    proceedWithApproved: '使用已批准的户外广告位继续',
    proceedNoneApproved: '尚无获批的户外广告位。',
    removeConfirmingHint: '您仍可移除等待答复的户外广告位。',
    proceedModalTitle: '使用已批准的户外广告位继续？',
    proceedOutdoorsLabel: '预订的户外广告位',
    proceedOutdoorsValue: '{{approved}} / {{total}}',
    proceedChargedLabel: '将扣款',
    proceedTotalMonthlyLabel: '活动总额',
    proceedModalNote: '此金额将立即从您的银行卡扣除。',
    proceedModalMonthlyNote: '首笔款项立即收取，其余通过直接扣款分期收取。',
    proceedModalDropped: '其他户外广告位（{{count}} 个）将从此活动中移除。',
    proceedSuccess: '您的活动已确认。',
    cancelDecisionTitle: '取消此活动？',
    cancelDecisionDesc: '已预授权的付款将被释放，不会扣款。所有户外广告位将对其他广告主开放。',
    unavailableTitle: '没有可用的户外广告位',
    unavailableDesc: '提供商无法确认这些日期，因此未扣款。请尝试其他日期或户外广告位。',
    feedback_CONFIRMING: '等待提供商',
    feedback_APPROVED: '已批准',
    feedback_UNAVAILABLE: '不可用',
    feedback_EXPIRED: '未答复',
    creativeThumbnailAlt: '活动 {{name}} 的创意素材',
    title: '广告活动',
    newCampaign: '新建活动',
    newCampaignTooltip: '点击创建新活动',
    mustRegisterAsAdvertiser: '您必须注册为广告主才能创建广告活动',
    noCampaigns: '暂无广告活动',
    noCampaignsDesc: '创建您的第一个活动，开始户外广告投放。',
    browseSpaces: '浏览广告空间',
    status: '状态',
    from: '从',
    to: '至',
    filter: '筛选',
    clearFilter: '清除筛选',
    outdoorSlots: '户外广告',
    outdoorsColHeader: '广告数',
    startDate: '开始日期',
    endDate: '结束日期',
    paginationRange: '第 {{from}}-{{to}} 个广告活动，共 {{total}} 个',
    creatives: '创意素材',
    payment: '支付',
    deleteTitle: '删除活动',
    deleteConfirm: '确定要删除此广告活动吗？此操作无法撤销。',
    uploadCreative: '上传创意',
    removeCreative: '移除',
    deletingCreative: '正在删除创意…',
    creativeRatioMismatch: '图片比例与所需的{{ratio}}格式不符。请上传比例正确的图片或PDF文件。',
    getPaymentDetails: '获取支付详情',
    requiredRatios: '所需创意比例',
    iban: 'IBAN',
    reference: '支付参考号',
    viewCampaign: '查看',
    loading: '加载广告活动中…',
    noSlots: '此活动中无广告位槽。',
    noCreatives: '尚未上传创意素材。',
    subtitle: '管理您的户外广告活动',
    noFound: '未找到广告活动',
    noFoundDesc: '先将户外广告添加到购物车，开始创建您的第一个广告活动。',
    browseOutdoors: '浏览户外广告',
    outdoorsCount: '{{count}} 个广告位',
    outdoorsCount_plural: '{{count}} 个广告位',
    creativesCount: '{{count}} 个创意素材',
    paymentLabel: '支付：{{status}}',
    backToCampaigns: '返回广告活动',
    checklistTitle: '广告活动清单',
    checklistOutdoors: '为您的广告活动选择广告位',
    checklistCreatives: '添加创意素材',
    checklistTerms: '接受条款和条件',
    checklistPay: '支付活动费用',
    acceptTermsPrefix: '我接受',
    acceptTermsLink: '条款和条件',
    acceptTermsRequiredHint: '您必须先接受条款和条件,才能为此广告活动付款。',
    advertiserTermsModalTitle: '广告主与广告活动条款和条件',
    advertiserTermsModalHint: '以下是我们条款和条件中专门适用于广告主和广告活动的部分。',
    viewFullTerms: '查看完整条款和条件',
    outdoorsHeader: '广告位 ({{count}})',
    noOutdoorsYet: '尚未添加广告位。',
    requiredAspectRatios: '所需创意比例',
    recResolution: '推荐: {{w}}×{{h}} 厘米 @ {{dpi}} dpi (1:{{scale}})',
    recInclBleed: '含裁切边距',
    dimensionsCalculatorBleedNote: '此广告位每边有 {{bleed}} 厘米裁切边距，因此尺寸涵盖 {{w}} × {{h}} m 的完整印刷区域（可见区域为 {{trimW}} × {{trimH}} m）。',
    orientationLandscape: '横向',
    orientationPortrait: '纵向',
    dimensionsCalculatorTooltip: '计算可用的创意尺寸',
    dimensionsCalculatorTitle: '比例为{{ratio}}的创意尺寸计算器',
    dimensionsCalculatorHint: '更改宽度或高度(厘米)，另一边会自动更新以保持该比例。我们始终以300 dpi制作，并推荐采用广告位实际尺寸的1:10比例。',
    dimensionsCalculatorWidthLabel: '宽度(cm)',
    dimensionsCalculatorHeightLabel: '高度(cm)',
    dimensionsCalculatorDpiLabel: '打印分辨率',
    dimensionsCalculatorScaleHint: '比例: 1:{{scale}} - 我们推荐1:10或更大的设计(比例数值更小)。',
    dimensionsCalculatorExportHint: '请以 {{w}} × {{h}} 像素导出您的文件。',
    dimensionsCalculatorMinQualityWidth: '尺寸过小，无法保证良好打印质量 - 1:{{scale}} 比例的设计至少需要 {{min}} 厘米。',
    dimensionsCalculatorMinQualityHeight: '尺寸过小，无法保证良好打印质量 - 1:{{scale}} 比例的设计至少需要 {{min}} 厘米。',
    processingImage: '正在处理图片...',
    noCreativesYet: '尚未上传创意素材',
    creativesNote: '这些是将在整个活动期间展示于户外广告牌上的图片。',
    clickToUpload: '点击上传',
    creativeValid: '已审批',
    creativeUnderReview: '审核中',
    creativeInvalid: '无效',
    deleteCreativeTitle: '删除创意？',
    deleteCreativeBody: '此创意已获批准或正在审核中。删除后将从活动中移除，需要重新上传。',
    campaignInfo: '广告活动信息',
    details: '详情',
    requestPayment: '申请付款',
    paymentDetails: '付款详情',
    currency: '货币',
    bankTransferDetails: '银行转账详情',
    amount: '金额',
    importantRef: '⚠️ 重要 - 支付参考号',
    refNote: '您必须在转账描述中包含此参考号，以便自动匹配。',
    deleteCampaign: '删除广告活动',
    deleteCampaignDesc: '这将永久删除此广告活动及所有相关数据。此操作无法撤销。',
    addOutdoor: '添加户外广告',
    outdoorAdded: '户外广告已添加至活动',
    selectOutdoor: '选择户外广告',
    outdoorDateConflict: '此户外广告在本次活动中已有重叠日期的预订。请选择不同的日期。',
    alreadyInCampaign: '已在活动中',
    name: '名称',
    outdoorSubtotal: '小计',
    bankTransferNoticeTitle: '需要完成广告活动付款',
    bankTransferNotice: '仅在付款全额确认后，您的广告活动才会正式启动，所有广告位也将完成预订。点击"验证并支付"继续操作。请注意：广告位的可用性将在结账时重新验证--最初加入活动时可用的位置可能已不再有保障。',
    requestPaymentDisabledHint: '在请求付款之前，所有{{count}}个必要的创意素材必须已上传并通过验证（状态：有效）。',
    outdoorRemoved: '户外广告已从活动中移除。',
    removeOutdoorConfirm: '确定要将此户外广告从活动中移除吗？此操作无法撤销。',
    qualityFail: '分辨率过低 - 文件未上传',
    qualityWarn: '宽高比不匹配 - 图像可能被裁剪或添加边距',
    qualityAspectMismatch: '宽高比 {{actual}} vs {{expected}}（户外广告牌）',
    qualityUploadAnyway: '仍然上传',
    qualityConfirmHint: '图像可能会被裁剪或添加边距以适应此格式。',
    qualityDetailFail: '此文件在 {{outdoorW}} × {{outdoorH}} m 的广告位上，清晰度仅相当于 {{achievedScale}}。',
    qualityTargetFail: '请以 {{w}} × {{h}} 厘米（1:{{scale}} 比例，{{dpi}} dpi）设计此格式的创意。',
    recResolutionPx: '推荐: {{w}}×{{h}}px @ {{dpi}} dpi',
    dimensionsCalculatorHintPx: '更改宽度或高度，另一边会自动更新以保持该比例；有效DPI也会随之更新，帮助您找到仍能保证良好印刷质量的其他尺寸。',
    dimensionsCalculatorWidthLabelPx: '宽度(px)',
    dimensionsCalculatorHeightLabelPx: '高度(px)',
    dimensionsCalculatorDpiLabelPx: '有效DPI',
    dimensionsCalculatorMinDpiHintPx: '此广告位至少需要{{dpi}} dpi。',
    dimensionsCalculatorMinQualityWidthPx: '宽度尚未达到最低质量要求(最小 {{min}}px，推荐 {{rec}}px)。',
    dimensionsCalculatorMinQualityHeightPx: '高度尚未达到最低质量要求(最小 {{min}}px，推荐 {{rec}}px)。',
    qualityWarnLowRes: '分辨率较低 - 图像打印质量可能较差',
    qualityConfirmHintLowRes: '图像打印时可能出现明显质量损失。',
    qualityDetailWarnPx: '{{pixelW}} × {{pixelH}} 像素在实际尺寸下产生 {{dpi}} DPI。',
    qualityDetailFailPx: '{{pixelW}} × {{pixelH}} 像素在 {{outdoorW}} × {{outdoorH}} m 处产生 {{dpi}} DPI，低于最低 {{minDpi}} DPI 要求。',
    qualityTargetWarnPx: '我们建议此格式至少 {{recDpi}} DPI：{{recW}} × {{recH}} 像素，或 {{recScaleLabel}}。',
    qualityTargetFailPx: '您至少需要 {{minW}} × {{minH}} 像素 - 以 1:{{scale}} 工作，即在 {{designDpi}} DPI 下 {{canvasW}} × {{canvasH}} m 的画布。',
    creativeUnitLabel: '尺寸单位',
    creativeUnitCm: '厘米',
    creativeUnitPx: '像素',
    creativeUnitHint: '选择推荐创意尺寸的显示和检查方式。厘米：按广告位实际尺寸的1:10比例设计，始终为300 dpi。像素：根据广告位尺寸确定最低分辨率。',
    previewBadge: '预览',
    previewOnlyHint: '仅为预览 - 请下载原文件用于印刷',
    downloadPrintFile: '下载印刷文件',
    downloadPrintFileHint: '全分辨率原文件',
    printFileExplainer: '上方图片为轻量预览。请下载全分辨率原文件用于印刷。',
    previewFailed: '无法在您的浏览器中为此文件生成预览。请将其导出为 JPG 或 PNG 后重试。',
    creativeFileRequirements: '可接受的文件：TIF、TIFF、JPG、JPEG、PNG 或 PDF。印刷需要 CMYK 颜色模式。其他颜色模式的图像将转换为 CMYK，并在上传前提供预览供您确认。PDF 文件须已为 CMYK。',
    creativeFormatNotAllowed: '“{{name}}”不是可接受的文件类型。请上传 TIF、TIFF、JPG、JPEG、PNG 或 PDF 文件。',
    creativeNotCmykPdf: '“{{name}}”包含 RGB 颜色（在作品或嵌入的图片中）。印刷文件必须完全为 CMYK——请使用 CMYK 颜色配置文件（例如 PDF/X-1a）重新导出后上传。',
    creativeUnreadable: '无法读取“{{name}}”。文件可能已损坏或以特殊方式保存——请重新导出后再试。',
    cmykNoticeTitle: '“{{name}}”不是 CMYK 颜色模式',
    cmykNoticeBody: '印刷需要 CMYK。我们可以使用户外广告印刷的标准配置文件为您转换，并在上传前向您展示转换前后的预览。',
    cmykConvert: '转换为 CMYK',
    cmykModalTitle: '转换为印刷用 CMYK',
    cmykConverting: '正在转换为 CMYK（{{profile}}）…',
    cmykBefore: '原图',
    cmykAfter: '印刷预览（CMYK）',
    cmykShiftWarning: '部分鲜艳的颜色在印刷时会有明显差异（约占图像的 {{percent}}%）。如需精确色彩，请在上传前于设计软件中调整作品。',
    cmykProfileNote: '使用户外广告印刷标准 {{profile}} 配置文件进行转换。屏幕无法精确显示 CMYK，因此预览为模拟的印刷效果。',
    cmykAccept: '采用转换后的 CMYK 版本',
    cmykErrorUnavailable: 'CMYK 转换暂时不可用。请在设计软件中将文件转换为 CMYK 后重新上传。',
    cmykErrorTooLarge: '此图像过大，无法在浏览器中转换。请在设计软件中将其转换为 CMYK 后重新上传。',
    cmykErrorFailed: '无法转换此文件。请在设计软件中将其转换为 CMYK 后重新上传。',
    pay: '验证并支付',
    commission: '平台佣金 ({{rate}}%)',
    vatLabel: '增值税',
    vatWithRate: '增值税 ({{rate}}%)',
    vatDetailsTitle: '增值税详情',
    vatDetailsBody: '增值税根据广告活动各组成部分所适用的税务处理方式计算。部分金额可能已含增值税、适用不同的增值税税率，或不属于适用的增值税征税范围。',
    totalWithoutVat: '总计（不含增值税）',
    grandTotal: '总计',
    dailyRateRoundingNote: '日费率四舍五入至最近的分。',
    platformFeeNote: '* 户外广告日费率已包含5%平台服务费。',
    confirmPayment: '确认付款',
    paymentSuccess: '付款成功！您的广告活动即将激活。',
    checkingPayment: '正在验证付款…',
    paymentConfirmed: '付款已确认！',
    paymentConfirmedDesc: '您的付款已确认。您的广告活动即将激活。',
    paymentPending: '付款未确认',
    paymentPendingDesc: '目前无法确认您的付款。请重试或联系支持团队。',
    backToCampaign: '返回广告活动',
    expandPricing: '显示价格详情',
    collapsePricing: '隐藏价格详情',
    availabilityUpdated: '您的广告活动中有一个或多个户外广告位已被移除--原因是它们已被其他广告活动预订（日期重叠），或其最短提前通知期已过。请查看下方更新后的选择。',
    availabilityDialogTitle: '确认可用性并继续付款',
    availabilityDialogBody: '在继续之前，我们将验证所有选定户外广告位是否仍然可用。其中一些可能已被其他广告活动预订。请说明您希望如何处理冲突。',
    availabilityRemoveYes: '是 - 自动删除不可用的户外广告位',
    availabilityRemoveYesDesc: '不再可用的广告位将从本次广告活动中删除。您可以在付款前查看更新后的选择。',
    availabilityRemoveNo: '否 - 标记冲突并手动审核',
    availabilityRemoveNoDesc: '冲突的广告位将被高亮显示，以便您在继续之前调整日期或手动删除。',
    availabilityDialogConfirm: '继续付款',
    outdoorFlaggedTitle: '日期已不再可用',
    outdoorFlaggedDesc: '该户外广告位已被其他广告活动预订了重叠日期。请编辑日期或将其删除以继续。',
    outdatedOutdoorsTitle: '广告活动无法继续 - 检测到过期的投放位',
    outdatedOutdoorsDesc: '一个或多个广告活动投放位的开始日期已过。付款未被处理。请检查下方标记的投放位并更新开始日期后重试。',
    outdoorOutdatedTitle: '开始日期已过',
    outdoorOutdatedDesc: '此投放位的预定开始日期已过。请将其更新为未来日期以继续。',
    pastStartDatesToast: '广告活动时间不能设置在过去。',
    cancelCampaign: '取消广告活动',
    cancelCampaignConfirm: '此操作将永久取消您的广告活动。您确定吗？',
    cancelCampaignYes: '是，取消',
    cancelCampaignAbort: '保留广告活动',
    cancelledSuccess: '广告活动已取消。',
    cancellationPolicyPending: '免费取消 - 广告活动处于待处理状态时取消不收取任何费用。',
    cancellationPolicyReady: '如所有户外广告的取消日期均早于各自空间提供商最低通知期限所要求的天数，则免收取消费用。若一个或多个户外广告处于其最低通知期限内，则须支付取消费用（葡萄牙公司需另加增值税）。处于最低通知期限内的户外广告，制作费（印刷、安装等）将不予退还。',
    cancellationPolicyRunning: '请注意：取消已在进行中的广告活动将导致100%的广告活动价值损失，不予任何退款。',
    ppInvoices: '刊位提供商的发票',
    outdoorAdj0: '精彩的',
    outdoorAdj1: '出色的',
    outdoorAdj2: '壮观的',
    outdoorAdj3: '绝佳的',
    outdoorAdj4: '卓越的',
    outdoorsCollapsedSummary: '这里有{{count}}个{{adj}}户外广告！',
    messages: '消息',
    noMessages: '目前尚无投放供应商就此广告活动发送任何消息。一旦有消息，相关对话将显示在此处。',
    noMessagesYet: '此对话中暂无消息。',
    typeMessage: '输入消息…',
    instructions: '对投放供应商的说明',
    instructionsPlaceholder: '例：请仅在上午8时至晚上10时显示此广告。',
    instructionsEmpty: '尚未添加说明。点击编辑为投放供应商添加指导内容。',
    instructionsSaved: '说明已保存。',
    proofOfDisplay: '展示证明',
    proofPending: '证明即将上传',
    proofPendingDesc: '您的空间提供商将很快上传展示证明照片。',
    proofAlt: '展示证明 – {{name}}',
    additionalFiles: '附加文件',
    additionalFilesSubtitle: '此活动的支持材料--非必填。',
    additionalFilesSubtitlePP: '广告主共享的支持材料。',
    noAdditionalFiles: '尚未上传任何附加文件。',
    uploadFile: '上传文件',
    fileUploaded: '文件上传成功。',
    fileDeleted: '文件已删除。',
    deleteFile: '删除文件',
    addOutdoors: '添加户外广告',
    creativesLockedTitle: '尚未添加户外广告',
    creativesLockedDesc: '素材必须符合每个户外广告所需的分辨率。请至少添加一个户外广告以启用上传。',
    editDates: '编辑日期',
    updateDates: '更新日期',
    datesUpdated: '日期更新成功',
  },
  dashboard: {
    title: '控制台',
    earnings: '收入',
    spendings: '支出',
    last30: '最近 30 天',
    last90: '最近 90 天',
    thisYear: '今年',
    accessRequests: '访问申请',
    noRequests: '暂无待处理申请',
    approve: '批准',
    reject: '拒绝',
    teamInvite: '邀请团队成员',
    inviteEmail: '电子邮件地址',
    sendInvite: '发送邀请',
    totalEarned: '总收入',
    totalSpent: '总支出',
    activeOutdoors: '活跃广告位',
    activeCampaigns: '活跃活动',
    overview: '概览',
    howPaidTitle: '如何获得付款',
    howPaidDesc: '活动上线后，请为每个广告牌上传实地照片证明。所有证明核实后，您的付款将自动释放。您的收益按您的日费率乘以广告活动的活跃天数计算，并扣除每次预订5%的平台服务费后结算。',
    ppOverview: '广告位提供商概览',
    advertiserOverview: '广告主概览',
    findOutdoors: '查找广告位',
    addOutdoor: '添加广告位',
    viewCampaigns: '查看广告活动',
    manageOutdoors: '管理广告位',
    companyDetails: '公司详情',
    userDetails: '账户详情',
    pendingRequests: '待处理访问申请 ({{count}})',
    inviteDesc: '他们将收到一封包含加入您公司链接的邮件。',
    invitePlaceholder: '同事@公司.com',
    invoicesTitle: '发票',
    downloadInvoice: '下载',
    invoiceIssued: '开具',
    invoicePaid: '已付',
    invoiceUnknownCampaign: '未知广告活动',
    invoicesSubtitle: '您的付款记录和可下载的发票文件。',
    invoicesEmpty: '期待为您填充此板块的内容！',
  },
  invoices: {
    title: '发票',
    subtitleAdvertiser: '您所有广告活动的Scapow及户外广告提供商发票。',
    subtitlePP: '您的付款记录和可下载的发票文件。',
    issued: '开具日期',
    download: '下载',
    empty: '暂无发票。广告活动处理完成后将在此显示。',
    unknownCampaign: '未知广告活动',
    ppInvoices: '广告位提供商发票（{{count}}张）',
    unknownProvider: '未知提供商',
    notAvailable: '不可用',
    typeInvoice: '发票',
    typeCreditNote: '贷记通知单',
  },
  payments: {
    title: '付款',
    subtitle: '您场地上广告活动的付款记录。',
    empty: '暂无付款记录。广告活动完成付款后将在此显示。',
    unknownCampaign: '未知广告活动',
    columnId: '付款编号',
    columnCampaign: '广告活动',
    columnValue: '金额',
    columnPaidAt: '付款日期',
    columnStatus: '状态',
    statusPaid: '已付款',
    statusTransferRequested: '已申请转账',
  },
  userDetails: {
    receiveEmails: '接收邮件',
    receiveEmailsOnDesc: '平台邮件将发送至 {{email}}。',
    receiveEmailsOffDesc: '您不会收到平台邮件。开启后即可重新接收。',
    emailsTurnedOn: '您将接收平台邮件。',
    emailsTurnedOff: '您将不再接收平台邮件。',
    emailsUpdateError: '无法更新您的邮件偏好设置。',
    title: '账户详情',
    subtitle: '管理您的个人账户信息。',
    name: '姓名',
    editName: '点击编辑',
    email: '电子邮箱',
    memberSince: '注册于 (UTC)',
    accountStatus: '账户状态',
    statusVerified: '已验证',
    statusPending: '待验证',
    nameUpdated: '姓名更新成功。',
    nameRequired: '请输入有效的姓名(至少2个字符)。',
    password: '密码',
    changePassword: '修改密码',
    currentPassword: '当前密码',
    newPassword: '新密码',
    confirmNewPassword: '确认新密码',
    passwordUpdated: '密码更新成功。',
    passwordFieldsRequired: '请填写所有密码字段。',
    passwordTooShort: '新密码必须至少包含8个字符。',
    passwordSameAsCurrent: '新密码必须与当前密码不同。',
    passwordMismatch: '新密码与确认密码不一致。',
  },
  admin: {
    tabUnpaidInstallments: '未付分期',
    unpaidInstallmentsIntro: '到期日后 6 天仍未支付的分期付款，按最早到期排序。',
    noUnpaidInstallments: '没有未付分期。',
    installmentOf: '第 {{number}} 期，共 {{total}} 期',
    installmentNumber: '第 {{number}} 期',
    installmentDue: '{{date}} 到期',
    installmentOverdueDays_one: '逾期 {{count}} 天',
    installmentOverdueDays_other: '逾期 {{count}} 天',
    proofOfCompany: '公司证明文件',
    openProofOfCompany: '在新标签页中打开 {{name}}',
    noProofOfCompany: '未上传公司证明文件',
    proofLocationLoading: '正在查找地址…',
    proofLocationViewMap: '在地图上查看',
    title: '管理员面板',
    verifications: '验证',
    advertisers: '广告主',
    providers: '提供商',
    payments: '支付',
    noVerifications: '暂无待验证',
    noPayments: '暂无待支付',
    markAsDone: '标记为已完成',
    business: '企业',
    type: '类型',
    status: '状态',
    actions: '操作',
    approve: '批准',
    reject: '拒绝',
    subtitle: '平台管理与审核',
    proofVerification: '手动审核',
    accessRequestsTab: '访问申请',
    noAccessRequests: '暂无待处理访问申请。',
    noAdvertisers: '未找到广告主。',
    noProviders: '未找到提供商。',
    noPaymentsStatus: '此状态下无支付记录。',
    campaignOutdoor: '广告活动广告位：{{id}}',
    campaignFrom: '{{date}} 的广告活动',
    adCreative: '广告创意素材',
    proofPhotos: '证明照片 ({{count}}) - 点击查看原尺寸',
    period: '期间',
    outdoorsLabel: '个广告位',
    campaignsLabel: '个广告活动',
    spentLabel: '支出',
    earnedLabel: '收入',
    markAsPaid: '标记为已付款',
    tabAds: '广告',
    tabBusinessProofs: '企业证明',
    tabProofOfAds: '广告证明',
    approved: '已批准',
    rejected: '已拒绝',
    noAds: '没有待处理的广告验证。',
    noBusinessProofs: '没有待处理的企业证明验证。',
    noProofOfAds: '没有待处理的广告证明验证。',
    refundsTab: '退款与债务',
    refundsSearchPlaceholder: '按活动名称或广告主名称搜索…',
    refundsNoCampaigns: '未找到活动。',
    refundsSelectOutdoors: '选择要退款的户外广告',
    refundsSelectAll: '全选',
    refundsDeselectAll: '取消全选',
    refundsNoEligible: '该活动中未找到符合条件的户外广告。',
    refundsEligibleNote: '只有未被拒绝的户外广告才符合退款条件。',
    refundsSubmit: '处理退款',
    refundsSuccess: '退款处理成功。',
    refundsSubTabRefunds: '广告主退款',
    refundsSubTabDebts: '供应商债务',
    refundTypeTotal: '全额',
    refundTypePartial: '部分',
    refundDaysLabel: '退款天数',
    refundDaysHint: '最多{{max}}天',
    debtNoDebts: '无未结供应商债务。',
    debtSettle: '结清',
    debtSettleAmount: '结清金额',
    debtSettleDoc: '结清文件',
    debtSettleDocHint: '上传已签署的结清文件（PDF、图片等）',
    debtSettleConfirm: '上传并结清',
    debtSettleSuccess: '债务已结清，文件上传成功。',
    debtStatusOutstanding: '未结清',
    debtStatusSettled: '已结清',
    debtCampaign: '活动',
    campaignsTab: '活动',
    noCampaigns: '未找到活动。',
    accessRequestFor: '申请访问：{{entity}}',
    tabByStatus: '按状态',
    tabTransferRequested: '转账申请',
    checkPayment: '检查',
    lastCheckedAt: '上次检查',
    neverChecked: '从未检查',
    noTransferRequested: '未找到转账申请付款。',
    checkSuccess: '付款检查已启动。',
    revenueTitle: '收入',
    revenueSubtitle: '平台佣金及增值税（按账期）',
    revenueGross: '总收入',
    revenueCommission: '佣金',
    revenueVat: '增值税',
    revenueStripeFees: 'Stripe手续费',
    revenueNet: '净收入',
    revenueEmpty: '本期无收入记录。',
    revenueMonth: '月',
    revenueYear: '年',
    revenueDailyTitle: '每日明细',
    revenueNoDaily: '本期无每日数据。',
    searchByName: '按名称搜索…',
    importOutdoorsFromFile: '从文件导入户外广告',
    chooseFile: '选择文件…',
    csvSend: '发送',
    importOutdoorsSuccess: '户外广告文件已成功发送。',
    remainingFreeCommissions: '剩余免佣金次数：{{count}}',
    setFreeCommissions: '设置新的剩余免佣金次数',
    freeCommissionsUpdated: '剩余免佣金次数已更新。',
    freeCommissionsUpdateFailed: '无法更新剩余免佣金次数。',
    verified: '已认证',
  },
  ppCampaigns: {
    searchAllStatuses: '正在显示所有状态的活动。清除搜索即可按状态筛选。',
    typeAll: '全部',
    typeScapow: 'Scapow',
    typeOffline: '线下',
    typeFilterLabel: '活动类型',
    noOfflineResults: '暂无线下活动。您可以在户外广告位页面将广告位添加到线下活动。',
    goToOutdoors: '前往户外广告位',
    offlineBadge: '线下',
    moreOutdoors: '另有 {{count}} 个',
    offlineNotes: '备注',
    payoutCommission: '平台佣金',
    payoutCommissionVat: '平台佣金增值税',
    payoutTransferred: '转账金额',
    payoutValueWithoutVat: '广告费（不含增值税）',
    payoutVat: '增值税',
    payoutProduction: '制作费（含增值税）',
    payoutsTitle: '收款',
    payoutsCount: '收款：{{count}} 笔',
    payoutsReceived: '已收金额',
    payoutFull: '全额收款',
    payoutFirst: '首笔收款 · {{month}}',
    payoutAfterProof: '预计自 {{date}} 起，在展示证明获批后支付',
    payoutExpectedOn: '预计 {{date}} 支付',
    payoutReceivedOn: '已于 {{date}} 收款',
    payoutProcessing: '转账处理中',
    payoutOnHold: '暂缓 - 广告主的直接扣款失败',
    payoutsOnHoldNotice: '由于广告主的直接扣款失败，一笔收款已暂缓。该付款成功后将立即发放。',
    payoutsNetNote: '金额已扣除 Scapow 佣金及其增值税，未扣除任何未结债务。',
    colProduction: '制作',
    title: '广告活动',
    subtitle: '监控和管理包含您户外广告位的广告活动。',
    tabPending: '待处理',
    tabReady: '就绪',
    tabRunning: '进行中',
    tabCompleted: '已完成',
    noResults: '未找到此状态的广告活动。',
    outdoorSlots: '{{count}}个户外广告位',
    outdoorSlots_plural: '{{count}}个户外广告位',
    instructions: '广告主指示',
    backToCampaigns: '返回广告活动列表',
    yourSlots: '您的户外广告位',
    noSlots: '此广告活动中未找到属于您的户外广告位。',
    advertiserInstructions: '广告主指示',
    messagesWithAdvertiser: '与广告主的消息',
    noConversation: '暂无消息。在下方输入开始与广告主的对话。',
    myInvoice: '我的发票（给广告主）',
    uploadInvoice: '上传发票',
    replaceInvoice: '替换发票',
    uploadInvoiceSuccess: '发票上传成功。',
    invoiceUploaded: '查看发票',
    noInvoiceYet: '尚未上传发票。',
    creativesAndOutdoors: '创意素材与您的广告位',
    noCreativeForRatio: '此格式尚未上传创意素材。',
    yourOutdoorsForFormat: '此格式对应的您的广告位',
    viewOutdoor: '查看广告位',
    goToCampaign: '前往活动页面',
    yourEarnings: '您的收益',
    readyPaymentTitle: '需要验证展示情况',
    readyPaymentNoteReady: '您的收益已锁定，等待活动启动。活动上线后，请为每个户外广告位上传安装证明，以启动付款流程。',
    readyPaymentNote: '如需释放收益，请在"验证展示"步骤中为每个户外广告位上传安装证明。',
    readyPaymentCta: '前往验证展示',
    paymentPaidTitle: '已收到付款',
    paymentPaidDesc: '此广告活动的收益已支付完成。',
    viewBreakdown: '查看明细',
    earningsBreakdown: '收益明细',
    colDays: '天数',
    colNetDailyValue: '日均价值 + 增值税',
    colEarnings: '收入',
  },
  upcomingCampaigns: {
    title: '即将开始的活动',
    subtitle: '包含您户外广告位、即将启动的活动。',
    noResults: '未找到即将开始的活动。',
  },
  getPaid: {
    title: '获取付款',
    subtitle: '按照以下步骤验证您的广告展示并获得付款。',
    step1: { label: '即将开始的活动', desc: '获取创意素材以设置户外广告' },
    step2: { label: '验证展示', desc: '上传广告证明以获得付款' },
    step3: { label: '已付发票', desc: '您的付款历史' },
    paidOn: '付款日期',
    downloadInvoice: '发票',
    noPayments: '暂无付款',
    noPaymentsDesc: '完成验证步骤以解锁付款。',
    upcomingEmpty: '目前没有即将开始的活动，请稍后再查看。',
    goToVerify: '前往验证展示',
    goToPaid: '查看付款',
    goToUpcoming: '查看即将开始的活动',
  },
  cart: {
    title: '您的购物车',
    empty: '购物车为空',
    emptyDesc: '搜索广告空间并加入购物车以创建活动。',
    browseOutdoors: '浏览户外广告',
    campaignDetails: '活动详情',
    campaignName: '活动名称',
    description: '描述（可选）',
    subtotal: '小计',
    total: '合计',
    remove: '移除',
    placeOrder: '创建广告活动',
    creating: '创建中…',
    estimatedCost: '预估费用',
    signInTitle: '登录以继续',
    signInDesc: '创建账户或登录以创建您的广告活动。',
    buildCampaign: '创建广告活动',
    estimatedTotal: '预估总计',
    campaignNamePlaceholder: '2025年夏季广告活动',
    detailsPlaceholder: '任何备注...',
    campaignLabel: '活动 {{n}}',
    selectCampaign: '添加到活动:',
    signInToCheckout: '请登录以创建此活动',
    advertiserRequired: '您需要广告主账户才能创建活动',
    instructions: '对投放供应商的说明（可选）',
    instructionsPlaceholder: '请在此填写对投放供应商的任何特殊说明...',
    instructionsHint: '您可以在创建活动后更新此字段。',
  },
  invitations: {
    title: '用户邀请',
    subtitle: '管理您企业的团队成员邀请',
    pendingTitle: '待处理邀请',
    noPending: '没有待处理的邀请',
    noPendingDesc: '在上方邀请团队成员以开始。',
    sentAt: '发送于',
    cancel: '取消',
    inviteSuccess: '邀请发送成功。',
    inviteError: '邀请发送失败。',
    cancelSuccess: '邀请已取消。',
    formTitle: '邀请团队成员',
    formDesc: '他们将收到一封包含加入您公司链接的邮件。',
    formPlaceholder: '同事@公司.com',
    formSend: '发送邀请',
  },
  terms: {
    back: '返回',
    title: '服务条款',
    effectiveDate: '生效日期：2026年6月19日 · SCAPOW · Codify, Unipessoal Lda',
    introBanner: '注册账户、访问或使用本平台，即表示您同意受本条款的法律约束。如不同意，请勿使用本平台。',
    footerNote: 'SCAPOW · Codify, Unipessoal Lda · 自2026年6月19日起生效',
    s1: '简介',
    s1_p1: '本服务条款（"条款"）规范对SCAPOW平台（"平台"）的访问和使用，平台由Codify, Unipessoal Lda（"公司"、"我们"、"我们的"）运营。',
    s1_p2: '平台作为数字市场连接以下各方：',
    s1_i1Bold: '广告主',
    s1_i1Rest: '，寻求购买营销活动广告位的一方；以及',
    s1_i2Bold: '空间提供商',
    s1_i2Rest: '，拥有、经营或控制物理广告空间的一方，包括但不限于广告牌、户外标识、数字显示屏及其他媒体位置。',
    s2: '使用资格',
    s2_p1: '用户必须：',
    s2_i1: '年满18周岁；',
    s2_i2: '具备订立具有约束力协议的法律行为能力；',
    s2_i3: '在注册时提供准确完整的信息；',
    s2_i4: '遵守所有适用的法律法规。',
    s2_p2: '企业用户声明其已获授权约束其公司或组织。',
    s3: '用户角色',
    s3_1: '3.1 广告主',
    s3_1_p1: '广告主可以：',
    s3_1_i1: '搜索、选择并购买广告位；',
    s3_1_i2: '上传广告素材；',
    s3_1_i3: '启动和管理广告活动。',
    s3_1_p2: '广告主对以下事项承担全部责任：',
    s3_1_i4: '广告内容的合法性；',
    s3_1_i5: '所使用全部知识产权的所有权或使用授权；',
    s3_1_i6: '遵守广告相关法律。',
    s3_2: '3.2 空间提供商',
    s3_2_p1: '空间提供商可以：',
    s3_2_i1: '列出可用广告空间；',
    s3_2_i2: '设置定价、活动可用性及运营要求；',
    s3_2_i3: '接受活动投放。',
    s3_2_p2: '空间提供商声明并保证其：',
    s3_2_i4: '拥有或合法控制该广告空间；',
    s3_2_i5: '持有商业广告使用所需的全部许可证、执照及权利；',
    s3_2_i6: '能够在约定时间内履行已预订的活动。',
    s3_3: '3.3 发布广告空间的法律声明',
    s3_3_p1: '在平台上发布户外广告空间时，每位空间提供商必须在提交时明确确认：',
    s3_3_i1: '其对所提交广告空间拥有合法权利；',
    s3_3_i2: '其有权将其用于商业目的；',
    s3_3_i3: '该发布符合所有适用法律、许可证、执照、分区法规及地方政府要求。',
    s3_3_p2: '此声明是发布的前提条件。未经此确认的提交将不予受理。平台保留删除任何声明被认定为虚假或误导性的发布，并暂停或终止提供不准确信息的空间提供商账户的权利。',
    s4: '平台角色',
    s4_p1: '平台仅作为中介和促进者。公司：',
    s4_i1: '不拥有广告空间；',
    s4_i2: '不充当广告主或空间提供商；',
    s4_i3: '不保证活动效果、曝光量或业务结果；',
    s4_i4: '不负责广告的实体安装或拆除。',
    s4_p2: '每笔交易在广告主与空间提供商之间形成直接合同关系。',
    s5: '活动预订',
    s5_p1: '活动预订在以下条件满足后具有约束力：',
    s5_i1: '广告主已完成结账 - 全额付款，或对于分期付款的活动，已授权首笔付款及后续各期的直接扣款；',
    s5_i2: '每个户外广告位均已确认 - 即时预订的广告位立即确认，其他广告位由其场地提供商在确认期内确认；',
    s5_i3: '活动开始日期已确定。',
    s5_p2: '所有预订均须遵守空间提供商规定的最低运营提前通知期。该期限确定广告主提交和支付活动的最后时间。未能满足此通知期可能导致拒绝或重新安排。',
    s6: '付款条款',
    s6_1: '6.1 广告主付款',
    s6_1_p1: '广告主按结账时所选的付款方式付款：',
    s6_1_i1: '一次性付清 - 活动总额在结账时扣款；',
    s6_1_i2: '按月或每三个月 - 制作费和首个计费期的费用在结账时扣款，其后每个计费期的费用在该期首日通过直接扣款收取。仅当活动超出其首个计费期时方可选择上述方式。',
    s6_1_p2: '结账须在活动开始日期之前且在场地提供商的最短通知期届满之前完成。如户外广告位需要确认，结账时仅对付款进行预授权，并在确认后仅就已确认的广告位扣款。任何分期款项的逾期付款适用第6.4条。如未能按时完成结账：',
    s6_1_i3: '预订可能被自动取消；',
    s6_1_i4: '空间提供商无义务预留广告空间。',
    s6_2: '6.2 平台费用',
    s6_2_p1: '平台可能收取服务费、佣金或交易费。此类费用将在购买前披露。平台费用不予退还，法律另有规定的除外。',
    s6_3: '6.3 空间提供商结算',
    s6_3_p1: '空间提供商仅在以下条件满足后才有资格获得付款：',
    s6_3_i1: '广告材料已完全安装；',
    s6_3_i2: '安装证明已通过平台上传；',
    s6_3_i3: '该证明在适用审核期内已获批准或未受到争议。',
    s6_3_p2: '证明必须包含清晰的照片证据，显示活动正确展示。平台保留验证真实性的权利。在欺诈、争议或未履行的情况下，付款可能被延迟、扣押或撤销。',
    s6_4: '6.4 付款义务与逾期付款',
    s6_4_p1: '每一项已确认的预订均构成广告主具有约束力的付款义务。广告主须按期足额支付其所预订的活动及户外广告位的全部款项，包括分期付款（按月或每三个月）活动的每一期款项。',
    s6_4_i1: '任何未在到期日前支付的款项（包括被拒绝、退回或撤销的直接扣款）自该日起即属逾期。平台将通知广告主，并可再次尝试收款。',
    s6_4_i2: '如与某一活动相关的任何款项自到期日起逾期超过两（2）个月，场地提供商可在不对广告主承担任何责任的情况下，从受影响的户外广告位撤下广告主的创意素材，并将该等广告位提供给其他广告主。',
    s6_4_i3: '该等撤下并不免除广告主的义务：所有已到期的款项，连同根据第9.3条适用的任何费用，仍须全额支付。',
    s6_4_i4: '平台和/或场地提供商可在适用法律允许的范围内采取法律行动，追讨任何未付款项，以及按适用法定利率计算的逾期利息和合理的追讨及法律费用。',
    s6_4_i5: '平台亦可依据第15条暂停广告主的账户，并在所有逾期款项结清前拒绝新的预订。',
    s6_4_p2: '依据本条撤下创意素材不构成场地提供商在第9.4条及第9.5条项下的不履约，亦不产生任何退款。',
    s7: '活动素材',
    s7_p1: '广告主必须在规定的截止日期内提交活动素材。素材必须：',
    s7_i1: '符合技术规格；',
    s7_i2: '可印刷且可使用；',
    s7_i3: '遵守适用法律；',
    s7_i4: '不含违法、诽谤、冒犯或侵权内容。',
    s7_p2: '空间提供商可拒绝不符合要求的素材。平台可自行决定删除内容。',
    s8: '安装证明',
    s8_p1: '空间提供商必须在安装后及时上传安装证明。未能提供证明可能导致：',
    s8_i1: '付款延迟；',
    s8_i2: '结算取消；',
    s8_i3: '从平台暂停。',
    s8_p2: '广告主可在上传后的适用争议期内对证明提出异议。如在此期间未提交异议，证明视为已被接受。',
    s9: '取消与退款',
    s9_1: '9.1 广告主取消',
    s9_1_p1: '如广告主取消：',
    s9_1_i1: '在空间提供商最低提前通知期之前：有资格退款，扣除适用费用；',
    s9_1_i2: '在提前通知期开始后：退款可能被拒绝。',
    s9_1_p2: '制作、印刷和准备费用可能不予退还。',
    s9_2: '9.2 空间提供商取消',
    s9_2_p1: '如空间提供商无正当理由取消已确认预订：',
    s9_2_i1: '广告主将获得全额退款；',
    s9_2_i2: '空间提供商可能面临罚款、可见性降低、暂停或账户终止。',
    s9_3: '9.3 广告活动取消政策',
    s9_3_i1: '处于待处理状态的广告活动可在付款前随时免费取消。',
    s9_3_i5: '若取消日期早于每项户外广告激活开始日期的天数超过相应空间提供商所规定的最低通知期限，则不收取任何取消费用，广告主将获得所有已付款项的全额退款。',
    s9_3_i2: '付款完成后，若活动中一个或多个户外广告的激活日期落在相应空间提供商所规定的最低通知期限内，则须支付广告活动总价值30%的取消费用。',
    s9_3_i3: '对于在葡萄牙注册的公司，取消费用将加收适用的增值税。',
    s9_3_i4: '若一个或多个户外广告的激活日期落在空间提供商所规定的最低通知期限内，制作费（印刷、安装等）将不予退还。',
    s9_3_i6: '取消已在进行中的广告活动将导致100%的广告活动价值损失，不予任何退款。',
    s9_3_i7: '若适用30%取消费用，广告活动总价值的20%将转移给相应的空间提供商，扣除平台标准5%佣金及适用增值税后支付。',
    s9_4: '9.4 未经证实的投放位退款',
    s9_4_p1: '如果广告位提供商未能在规定时间内为一个或多个户外广告位提交有效的展示证明，Scapow将按以下方式向广告主发放退款：',
    s9_4_i1: '在广告活动期间内，投放位未能展示广告主创意的每一天，将按比例向广告主退还该投放位的日均价值。',
    s9_4_i4: '对因未展示天数而退还的总金额将收取10%的取消费，另加适用的增值税。',
    s9_4_i2: '退款将在确认未提供展示证明或证明被认定无效后的合理时间内处理。',
    s9_4_i3: '适用于已证实并已完成投放位的平台服务费不予退还。',
    s9_5: '9.5 展示位置提供商的不履行 - 活动部分履行',
    s9_5_p1: '如展示位置提供商未能在约定的活动期间内全程展示广告主的活动素材，则其未能履行约定展示义务的每一天均构成"不履行日"。',
    s9_5_a: 'a) 对Scapow的财务责任',
    s9_5_p2: '就每个不履行日而言，展示位置提供商须就相关活动位置适用的日广告价值费率所对应的金额（"不履行金额"）向平台承担责任。不履行金额的追偿由平台自行决定，可通过以下一种或多种方式进行：',
    s9_5_i1: '(i) 要求展示位置提供商在平台发出的书面通知所规定的期限内，直接向平台汇付不履行金额；或',
    s9_5_i2: '(ii) 从展示位置提供商应获得的当前或未来活动款项中扣除不履行金额，无论该款项属于同一活动还是平台上的后续合作。',
    s9_5_p3: '平台保留在必要范围内同时适用上述两种救济方式的权利，以全额追偿不履行金额总额。',
    s9_5_b: 'b) 向广告主的全额补偿',
    s9_5_p4: '就每个不履行日而言，广告主有权就该日所支付的全部款项获得全额退款，包括相应的日活动费率、适用的平台佣金以及归属于该日的任何服务费或交易费。上述退款将在确认不履行后，由平台在合理期限内予以处理。',
    s9_5_c: 'c) 不履行的认定',
    s9_5_p5: '约定展示期限的不履行将依据通过平台提交的证据进行评估，包括但不限于展示证明记录、广告主报告、照片文件及平台认为相关的任何其他材料。平台的认定对于计算不履行金额及处理广告主退款具有最终效力和约束力，但不影响双方依据适用法律所享有的合法权利。',
    s9_6: '9.6 不可抗力 - 自然灾害',
    s9_6_p1: '"不可抗力事件"是指超出广告主和场地提供商合理控制范围的自然灾害或相关紧急情况，导致户外广告位在物理上无法展示广告主的创意素材，或使展示变得不安全，包括地震、洪水、风暴、飓风、山火、山体滑坡、主管部门发布的疏散令或紧急命令，以及由此类事件导致的停电。普通恶劣天气、正常损耗和缺乏维护不属于不可抗力事件。',
    s9_6_a: 'a) 通知与证据',
    s9_6_p2: '场地提供商须在知悉不可抗力事件后48小时内通过平台报告，并附上证据（如照片或官方警报）及预计恢复日期。平台将根据该等证据评估事件是否符合条件；就本条而言，平台的认定为最终认定并具有约束力。',
    s9_6_b: 'b) 对场地提供商的影响',
    s9_6_i1: '因符合条件的不可抗力事件而无法展示的每一天（"不可抗力日"）不构成第9.5条所述的不合规日，且无需就此支付任何违约金额。',
    s9_6_i2: '对于不可抗力日，平台无需向场地提供商支付任何款项。',
    s9_6_i3: '场地提供商须在不可抗力事件结束后5个工作日内恢复展示。超过该期限仍未恢复展示的每一天，均构成第9.5条所述的不合规日。',
    s9_6_i4: '场地提供商仍须负责其结构的维护和适当投保，包括重新印刷和重新安装因该事件而损坏或毁损的创意素材的费用。',
    s9_6_c: 'c) 对广告主的影响',
    s9_6_i5: '广告主有权就不可抗力日已支付的全部款项获得全额退款，包括每日活动费用、相应的平台佣金及适用的增值税，且不收取第9.4条所述的10%手续费。',
    s9_6_i6: '作为替代，广告主可选择将受影响的天数顺延至活动结束时，但须视该户外广告位的可用情况而定。',
    s9_6_i7: '如户外广告位在投放开始前因不可抗力事件而无法使用，尽管有第9.3条的规定，广告主或场地提供商均可将其从活动中移除且不收取任何取消费用，广告主将获得该广告位已付款项的全额退款。',
    s9_6_i8: '如不可抗力事件持续超过14天，或超过受影响广告位剩余活动期的一半，广告主可免费取消该广告位的剩余部分，并获得剩余天数的退款。',
    s9_6_i9: '对于按月分期付款的活动，未来的分期款项将相应减少或取消。',
    s9_6_d: 'd) 适用范围',
    s9_6_p3: '仅影响广告主自身业务而不影响户外广告位的事件不属于本条范围，适用第9.3条的活动取消政策。',
    s9_7: '9.7 蓄意破坏',
    s9_7_p1: '"蓄意破坏"是指与广告主和场地提供商无关的第三方故意损坏、涂污或移除户外广告位或广告主的创意素材，例如涂鸦、被撕毁或遮盖的海报，或受损的屏幕或结构。',
    s9_7_i1: '场地提供商须在知悉蓄意破坏后48小时内通过平台报告，并附上照片及（如有）报警记录。',
    s9_7_i2: '场地提供商须在报告后3个工作日内自费恢复展示，包括重新印刷和重新安装创意素材。',
    s9_7_i3: '在该恢复期内无法展示的天数按第9.6条所述的不可抗力日处理：广告主有权获得全额退款且不收取手续费，亦无需支付任何违约金额。',
    s9_7_i4: '超过恢复期的天数，或因场地提供商未采取合理预防措施而导致的蓄意破坏，均构成第9.5条所述的不合规日。',
    s9_7_i5: '如同一户外广告位在30天内遭受三次或以上蓄意破坏，场地提供商须采取合理的预防措施，广告主可免费取消该广告位的剩余部分并获得剩余天数的退款。',
    s9_7_p2: '报告未实际发生的不可抗力事件或蓄意破坏，将被视为第12条所述的提交虚假展示证明，并可能导致账户被立即暂停或终止。',
    proofProtectionNote: '您的投资受到保护：如有任何户外广告位未能提供经验证的展示证明，Scapow将退还该投放位对应的金额。',
    s10: '争议',
    s10_p1: '用户同意首先尝试通过平台解决争议。平台可以：',
    s10_i1: '审查活动证据；',
    s10_i2: '要求补充文件；',
    s10_i3: '作出不具约束力的决定。',
    s10_p2: '平台的决定不替代适用法律下的合法权利。',
    s11: '知识产权',
    s11_p1: '广告主保留其提交内容的所有权。',
    s11_p2: '通过上传素材，广告主授予平台和空间提供商有限、非独占的许可，仅用于履行活动目的使用、复制和展示此类素材。',
    s11_p3: '空间提供商保留其发布信息、图片和位置数据的所有权。',
    s11_p4: '平台保留所有平台软件、品牌和系统的所有权。',
    s12: '禁止行为',
    s12_p1: '用户不得：',
    s12_i1: '实施欺诈；',
    s12_i2: '上传误导性或违法内容；',
    s12_i3: '规避付款；',
    s12_i4: '在平台外联系用户以规避费用；',
    s12_i5: '操纵评价或活动结果；',
    s12_i6: '上传虚假安装证明。',
    s12_p2: '违规可能导致立即暂停或终止账户。',
    s13: '责任限制',
    s13_p1: '在法律允许的最大范围内，平台不对以下情况承担责任：',
    s13_i1: '活动效果不佳；',
    s13_i2: '天气损害、自然灾害和蓄意破坏（受第9.6条和第9.7条约束）；',
    s13_i3: '第三方造成的延误；',
    s13_i4: '非平台造成的印刷缺陷；',
    s13_i5: '用户的行为或不作为。',
    s13_p2: '总责任不超过相关活动支付给平台的总费用。',
    s14: '赔偿',
    s14_p1: '用户同意就以下原因产生的任何索赔、损失、损害、责任或费用对公司进行赔偿并使其免受损害：',
    s14_i1: '违反本条款；',
    s14_i2: '违法广告内容；',
    s14_i3: '侵犯第三方权利；',
    s14_i4: '欺诈行为。',
    s15: '账户暂停',
    s15_p1: '平台可能因以下原因暂停或终止账户：',
    s15_i1: '欺诈；',
    s15_i2: '未付款；',
    s15_i3: '反复争议；',
    s15_i4: '滥用平台；',
    s15_i5: '违反本条款。',
    s16: '税务',
    s16_p1: '用户对其自身税务负责，包括增值税、销售税、所得税及其他适用税款。在法律要求的情况下，平台可能代收税款。',
    s17: '数据保护',
    s17_p1: '用户数据将依据平台隐私政策及适用的数据保护法律进行处理。用户有责任确保其对上传的任何个人数据享有合法权利。',
    s18: '适用法律',
    s18_p1: '本条款受适用法律管辖，不考虑法律冲突原则。争议应提交有管辖权的法院专属管辖。',
    s19: '条款修订',
    s19_p1: '平台可随时修订本条款。修订后继续使用平台即视为接受修订内容。',
    s20: '联系方式',
    s20_p1: '如有法律咨询：',
  },
  team: {
    title: '团队管理',
    subtitle: '管理团队成员并发送邀请',
    tabUsers: '活跃成员',
    tabInvitations: '邀请',
    noUsers: '暂无活跃成员',
    noUsersDesc: '用户接受邀请后将出现在此处',
    statusVerified: '已验证',
    statusPending: '待处理',
  },
  footer: {
    tagline: '连接户外广告业主与广告主的交易平台。简单、高效、有力。',
    platform: '平台',
    browseOutdoors: '浏览户外广告',
    createAccount: '创建账户',
    logIn: '登录',
    forBusinesses: '企业服务',
    registerBusiness: '注册企业',
    listOutdoors: '发布广告位',
    runCampaigns: '投放活动',
    about: '关于',
    howItWorks: '使用方法',
    mission: '我们的使命',
    contactUs: '联系我们',
    copyright: '© 2025 Scapow by Codify。保留所有权利。',
    privacy: '隐私政策',
    terms: '服务条款',
  },
  language: {
    select: '语言',
    en: 'English',
    pt: 'Português',
    es: 'Español',
    de: 'Deutsch',
    zh: '中文',
    ja: '日本語',
    fr: 'Français',
    it: 'Italiano',
  },
  verification: {
    title: '广告活动户外广告验证',
    subtitle: '为待验证的活跃广告活动户外广告提交证明照片。广告活动中的所有户外广告位均完成验证后，广告活动付款才会解锁。',
    empty: '无待处理验证',
    emptyDesc: '您所有活跃的广告活动户外广告均已是最新状态。广告活动上线后请再次查看。',
    uploadProof: '上传证明照片',
    uploaded: '证明已提交',
    uploadSuccess: '证明照片提交成功。',
    noName: '广告活动户外广告',
    locating: '正在定位…',
    awaitingVerification: '待验证',
    verified: '已验证',
    partiallyVerified: '部分验证',
    backToCampaigns: '返回广告活动列表',
    noOutdoors: '未找到此广告活动的户外广告位',
    pendingCount: '{{count}} 个待处理',
    notYetAvailable: '自 {{date}} 起可进行验证',
    viewProof: '查看证明照片',
    proofAlt: '证明照片',
    deleteProof: '删除证明',
    deleteProofSuccess: '证明照片已删除。',
    deleteProofConfirm: '您确定要删除此证明照片吗？此操作无法撤销。',
  },
  howItWorksPage: {
    title: '使用方式',
    subtitle: '无论您是户外广告空间拥有者还是希望触达新受众，Scapow让一切变得简单。',
    advertiserTab: '广告主',
    ppTab: '空间提供商',
    advertiserTitle: '大规模触达您的受众',
    advertiserSubtitle: '在一个直观的平台上规划、启动和追踪户外广告活动。',
    adStep1Title: '发现合适的空间',
    adStep1Desc: '在互动地图上浏览数千个经验证的户外广告位置。按城市、格式、尺寸、可用性和日费率筛选，找到活动的完美地点。',
    adStep2Title: '构建您的广告活动',
    adStep2Desc: '选择多个户外广告位并将它们组合成一个活动。设置日期、上传创意素材并确认计划--无需代理机构。',
    adStep3Title: '安心付款',
    adStep3Desc: '在确认前获得透明的费用明细。通过我们的平台和安全支付网关安心付款，并获得正式发票--一切都有记录和可追溯。',
    adStep4Title: '追踪每次投放',
    adStep4Desc: '活动上线后，空间提供商提交户外广告的照片证明。直接从您的仪表板监控状态和确认情况。',
    ppTitle: '将您的空间转化为收益',
    ppSubtitle: '一次发布，触达数千广告主，按您的节奏获得收益。',
    ppStep1Title: '发布您的空间',
    ppStep1Desc: '为每个户外广告位置创建详细的列表。添加尺寸、照片、定价和可用性。列表越详尽，吸引的活动越多。',
    ppStep2Title: '与广告活动匹配',
    ppStep2Desc: '您的空间会自动出现在广告主的搜索结果中。当您被选中参与活动时，您将收到通知和确认预订--无需谈判。',
    ppStep3Title: '上传展示证明',
    ppStep3Desc: '一旦您的户外广告开始展示活动内容，通过平台上传照片证明。这是您的交付确认--并触发付款流程。',
    ppStep4Title: '收取款项',
    ppStep4Desc: '一旦某个活动中所有户外广告位的展示证明均已提交，付款将按约定条款释放。您在该活动中的所有广告位均须经过验证后方可处理款项--确保完整交付后方可结算。',
    ctaTitle: '准备好开始了吗？',
    ctaSubtitle: '加入数千家已在Scapow上成长的企业。',
    ctaAdvertiser: '开始投放广告',
    ctaProvider: '发布我的空间',
  },
  brand: {
    slogan: "it's ooh good!",
  },
  missionPage: {
    title: '我们的使命',
    subtitle: '连接户外广告市场--让每个空间创造影响力，让每个活动找到其受众。',
    coreTitle: '驱动我们的力量',
    coreDesc: '户外广告行业是碎片化的。优质空间无人预订。活动未能发挥其潜力。我们相信技术可以改变这一切--而Scapow就是方式。',
    pillar1Title: '扩大覆盖和影响力',
    pillar1Desc: '我们使广告主能够从单一统一平台规划和执行多地点的高影响力户外广告活动--大规模触达受众，无需运营负担。',
    pillar2Title: '最大化提供商收益',
    pillar2Desc: '我们为空间提供商提供直接访问合格广告需求池的渠道，减少空置库存，确保他们的空间产生稳定、可预期的收益。',
    pillar3Title: '连接静态OOH市场',
    pillar3Desc: '我们正在构建户外广告行业长期所需的基础设施--一个透明的数字优先市场，供需能够高效、公平、大规模地对接。',
    pillar4Title: '通过透明建立信任',
    pillar4Desc: '从企业资质验证到展示照片证明，Scapow流程的每一步都旨在可审计、负责任，并建立在各方相互信任的基础上。',
    visionTitle: '我们的愿景',
    visionDesc: '一个每个户外空间都是机遇的世界--每个品牌都能在其受众生活、工作和移动的任何地方找到完美的展示舞台。',
    closingTitle: '构建OOH的未来',
    closingDesc: 'Scapow不仅仅是一个市场。它是户外广告行业的连接纽带--将空间提供商、广告主和推动他们共同成功的技术汇聚在一起。',
  },
  contact: {
    label: '联系我们',
    title: '联系我们',
    subtitle: '有问题、反馈，或只是想打个招呼？我们很乐意听到您的声音。',
    infoTitle: '我们来聊聊',
    infoDesc: '无论您对功能、定价还是其他方面有疑问--我们的团队随时准备回答您的所有问题。',
    responseTimeTitle: '快速响应',
    responseTimeDesc: '我们通常在24小时内回复。',
    emailTitle: '发送邮件',
    whatsappTitle: 'WhatsApp',
    formTitle: '给我们发消息',
    fieldName: '您的姓名',
    fieldEmail: '您的邮箱',
    fieldSubject: '主题',
    fieldMessage: '消息',
    namePlaceholder: '张三',
    emailPlaceholder: 'you@example.com',
    subjectPlaceholder: '我们能帮您什么？',
    messagePlaceholder: '告诉我们您的想法…',
    submit: '发送消息',
    submitting: '发送中…',
    successTitle: '消息已发送！',
    successDesc: '感谢您的联系，我们将很快与您取得联系。',
    backHome: '返回首页',
    errorRequired: '此字段为必填项。',
    errorEmail: '请输入有效的电子邮件地址。',
  },
  calendar: {
    calendarMonthsHint: '按整个自然月预订（从1日到月末）。点击某个1日开始，点击之后的日期添加该月，点击预订范围内的日期可缩短预订。',
    startOnMonthFirstHint: '预订从某个月的1日开始。',
    fullMonthHint: '按月预订：选择开始日，然后点击之后的日期以增加月份 - 每个月都在下个月的同一天结束（从1日开始则在当月最后一天结束）。点击预订范围内的日期可缩短预订。',
    discountsTitle: '预订越久，越省钱',
    discountTier: '{{days}} 天及以上',
    discountsPickStart: '选择开始日期，即可查看哪些结束日期享有折扣。',
    discountsHighlighted: '绿色越深，折扣越大；标签显示每档折扣的起始日。',
    discountApplied: '这 {{count}} 天可享 {{percentage}}% 折扣',
    discountNextTier: '再加 {{days}} 天即可节省 {{percentage}}%',
    latestStartInfo: '开始日期最晚可选 {{date}}',
    blockedLegend: '已封锁 / 不可用',
    pendingLegend: '待处理（尚未保存）',
    loading: '正在加载可用性…',
    noticeRequired: '最早开始日期：{{date}}（需提前 {{count}} 天预订）',
    minimumDaysError: '最少租赁 {{count}} 天--请延长您的选择',
    overlapError: '所选范围包含已预订日期--请仅选择连续的可用天数',
  },
  approvals: {
    thisBookingLegend: '此预订',
    blockedSelection: '屏蔽时段：',
    blockedSelectionEmpty: '请在日历中选择开始和结束日期。',
    title: '审批',
    subtitle: '请确认您的户外广告位是否可用于这些已付款活动。',
    emptyTitle: '暂无待处理事项',
    emptyDesc: '当广告主预订您的户外广告位时，会显示在这里等待您审批。',
    campaignFallback: '活动',
    outdoorsToReview: '待审核户外广告位：{{count}}',
    startsOn: '开始于 {{date}}',
    answerBy: '答复截止 {{date}}',
    review: '审核',
    youEarn: '您将获得',
    backToList: '返回审批列表',
    reviewEyebrow: '审批请求',
    summaryLine: '户外广告位：{{count}} · 您将获得 {{value}}',
    deadlineNotice: '请在 {{date}} 前答复。未按时答复的户外广告位将从活动中移除。',
    progress: '已答复 {{answered}} / {{total}}',
    approveAll: '全部批准',
    available: '可用',
    unavailable: '不可用',
    decisionFor: '{{name}} 是否可用？',
    decisionRequired: '请选择一个答复。',
    blockedHint: '请告诉我们此户外广告位何时已被占用，我们将屏蔽这些日期。',
    blockedFrom: '屏蔽开始',
    blockedTo: '屏蔽结束',
    blockedRequired: '两个日期均为必填。',
    blockedOrder: '结束日期不能早于开始日期。',
    viewCreative: '查看 {{name}} 的创意素材',
    noCreative: '暂无创意素材',
    feedbackMandatory: '每个户外广告位都需要答复。',
    submit: '提交答复',
    fixBeforeSubmit: '请答复所有户外广告位并检查屏蔽日期。',
    confirmTitle: '提交您的答复？',
    confirmSummary: '可用：{{approved}} · 不可用：{{unavailable}}',
    confirmNote: '答复提交后无法更改。',
    submitted: '谢谢，您的答复已提交。',
    submitError: '无法提交您的答复。',
    allAnsweredTitle: '已答复',
    allAnsweredDesc: '您已答复此活动中的所有户外广告位。',
    loadErrorTitle: '此审批不可用',
    loadErrorDesc: '可能已被答复，或活动已取消。',
  },
  status: {
    installment: {
      SCHEDULED: '已排期',
      PROCESSING: '处理中',
      PAID: '已支付',
      FAILED: '失败',
      CANCELLED: '已取消',
    },
    campaign: {
      PENDING: '草稿',
      AWAITING_PAYMENT: '待付款',
      CONFIRMING: '等待提供商',
      AWAITING_CONFIRMATION: '需要决定',
      READY: '已确认',
      RUNNING: '投放中',
      COMPLETED: '已完成',
      CANCELLED: '已取消',
      UNAVAILABLE: '不可用',
    },
    payment: {
      PENDING: '未付款',
      VALIDATING_PAYMENT: '正在验证付款',
      MANUAL_VALIDATION: '审核中',
      TRANSFER_REQUESTED: '已申请转账',
      PAID: '已付款',
      CANCELLED: '已取消',
      PARTIALLY_REFUNDED: '部分退款',
      FULLY_REFUNDED: '已退款',
      FAILED: '失败',
    },
    campaignOutdoor: {
      PENDING: '等待证明',
      VERIFYING: '正在验证证明',
      FOR_MANUAL_APPROVAL: '证明审核中',
      APPROVED: '证明已批准',
      REJECTED: '证明被拒',
      REFUNDED: '已退款',
      CANCELLED: '已取消',
    },
    proof: {
      PENDING: '待处理',
      VALID: '有效',
      MANUAL_VALIDATION: '审核中',
      INVALID: '无效',
    },
    paymentType: {
      BUYING_ADS: '广告购买',
      SELLING_ADS: '支付给提供商',
      REFUND_BUYING_PART: '退款给广告主',
      REFUND_SELLING_PART: '提供商退款',
      PLACEMENT_PROVIDER_DEBT: '提供商欠款',
      PLACEMENT_PROVIDER_CANCELLATION_FEE: '取消补偿',
    },
  },
  offlineCampaigns: {
    creativesTitle: '创意素材',
    creativesSubtitle: '待安装的画面。任何尺寸均可 - 由您决定如何适配每个户外广告位。',
    uploadCreatives: '上传创意素材',
    noCreatives: '暂无创意素材。点击上传 JPG、PNG、TIFF 或 PDF 文件。',
    creativesUploaded: '创意素材已上传。',
    creativeRemoved: '创意素材已删除。',
    removeCreative: '删除创意素材',
    removeCreativeConfirm: '要删除此创意素材吗？此操作无法撤销。',
    downloadOriginal: '下载原文件',
    filesTitle: '文件',
    filesSubtitle: '合同、简报或此活动的其他任何文件。',
    uploadFiles: '上传文件',
    noFiles: '尚未上传文件。',
    filesUploaded: '文件已上传。',
    fileRemoved: '文件已删除。',
    removeFile: '删除文件',
    removeFileConfirm: '要删除“{{name}}”吗？此操作无法撤销。',
    download: '下载',
    remove: '删除',
    outdoorsTitle: '户外广告位',
    noOutdoors: '此活动还没有户外广告位。',
    modalTitle: '添加到线下活动',
    newTitle: '新建线下活动',
    pickTitle: '选择线下活动',
    datesTitle: '选择日期',
    doneTitle: '已添加户外广告位',
    forOutdoor: '户外广告位：',
    optionNew: '新建',
    optionNewDesc: '为在 Scapow 之外售出的预订创建活动。',
    optionPick: '从现有中选择',
    optionPickDesc: '将其添加到您的某个线下活动中。',
    name: '活动名称',
    nameRequired: '请为活动命名。',
    details: '详情',
    detailsHint: '例如：售出渠道或客户。',
    notes: '备注',
    notesHint: '内部备注 - 仅您的团队可见。',
    instructions: '说明',
    instructionsHint: '供安装创意素材的人员参考。',
    createAndContinue: '创建并继续',
    createError: '无法创建线下活动。',
    addError: '无法将户外广告位添加到活动中。',
    noneYet: '您还没有线下活动。',
    outdoorsCount: '户外广告位：{{count}}',
    createdOn: '创建于 {{date}}',
    datesIntro: '请选择该户外广告位为“{{campaign}}”预订的日期。已被占用的日期会显示且无法选择。',
    pickDates: '请在日历中选择开始和结束日期。',
    addToCampaign: '添加到活动',
    doneMessage: '已将 {{outdoor}} 添加到“{{campaign}}”。',
    doneHint: '这些日期现已对其他预订屏蔽。',
    backToSearch: '返回搜索',
    getAvailability: '查看可用性',
    clearAvailability: '清除可用性',
    availabilityTitle: '查看可用性',
    availabilityHint: '选择开始和结束日期，仅显示整个期间都空闲的户外广告位。',
    showAvailable: '显示可用的户外广告位',
    dimensionsLabel: '尺寸',
    noMatches: '没有符合这些筛选条件的户外广告位',
    noMatchesHint: '请尝试其他尺寸或日期，或清除筛选条件。',
    clearFilters: '清除筛选',
    addButton: '添加到线下活动',
    addTooltip: '添加到非通过 Scapow 预订的活动',
  },
};

export default zh;
